import React, { useState } from "react";
import { Download, Search, RefreshCcw } from "lucide-react";

const Logs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("all");
  const [timeRange, setTimeRange] = useState("1h");

  const logs = [
    {
      id: 1,
      timestamp: "2024-02-16T10:23:00",
      level: "ERROR",
      source: "Database",
      message: "Connection timeout after 5000ms",
      details: {
        error: "ETIMEDOUT",
        connection: "primary",
        attempted: 3,
      },
    },
    {
      id: 2,
      timestamp: "2024-02-16T10:22:30",
      level: "INFO",
      source: "Authentication",
      message: "User login successful",
      details: {
        userId: "user123",
        method: "password",
      },
    },
    {
      id: 3,
      timestamp: "2024-02-16T10:21:00",
      level: "WARNING",
      source: "API Gateway",
      message: "Rate limit approaching threshold",
      details: {
        current: 950,
        limit: 1000,
        timeWindow: "1m",
      },
    },
  ];

  const getLevelStyle = (level) => {
    const styles = {
      ERROR: "bg-red-100 text-red-800",
      WARNING: "bg-yellow-100 text-yellow-800",
      INFO: "bg-blue-100 text-blue-800",
      DEBUG: "bg-gray-100 text-gray-800",
    };
    return styles[level] || "bg-gray-100 text-gray-800";
  };

  const handleExport = () => {
    const csvContent = logs
      .map(
        (log) => `${log.timestamp},${log.level},${log.source},"${log.message}"`
      )
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "system-logs.csv";
    a.click();
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold">System Logs</h1>
          <p className="text-gray-600">View and analyze system activity logs</p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={handleExport}
            className="flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-gray-50"
          >
            <Download size={16} />
            Export
          </button>
          <button className="flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-gray-50">
            <RefreshCcw size={16} />
            Refresh
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="flex gap-4 items-center">
        <div className="flex-1 relative">
          <Search
            size={16}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          />
          <input
            type="text"
            placeholder="Search logs..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border rounded-lg"
          />
        </div>
        <select
          value={selectedLevel}
          onChange={(e) => setSelectedLevel(e.target.value)}
          className="px-4 py-2 border rounded-lg"
        >
          <option value="all">All Levels</option>
          <option value="error">Error</option>
          <option value="warning">Warning</option>
          <option value="info">Info</option>
          <option value="debug">Debug</option>
        </select>
        <select
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          className="px-4 py-2 border rounded-lg"
        >
          <option value="1h">Last Hour</option>
          <option value="6h">Last 6 Hours</option>
          <option value="24h">Last 24 Hours</option>
          <option value="7d">Last 7 Days</option>
        </select>
      </div>

      {/* Logs Table */}
      <div className="border rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Timestamp
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Level
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Source
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Message
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Details
                </th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {logs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {new Date(log.timestamp).toLocaleString()}
                  </td>
                  <td className="px-4 py-3">
                    <span
                      className={`inline-block px-2 py-1 rounded text-xs font-medium ${getLevelStyle(
                        log.level
                      )}`}
                    >
                      {log.level}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm">{log.source}</td>
                  <td className="px-4 py-3 text-sm">{log.message}</td>
                  <td className="px-4 py-3 text-sm">
                    <pre className="text-xs bg-gray-50 p-2 rounded">
                      {JSON.stringify(log.details, null, 2)}
                    </pre>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Logs;
